import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE, DESC_ORDER } from "@duosoftbg/nacid-components";
import { UsersFilter } from "../types/userTypes";

export const usersFilterInitialValues: UsersFilter = {
  name: "",
  username: "",
  email: "",
  enabled: "",
  emailVerified: "",
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
  order: DESC_ORDER,
  orderBy: "name",
};
